class TransfersController {
	constructor(TransfersFactory, TeamsFactory, PlayersFactory, $filter, ngDialog, $stateParams, $state, $rootScope){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		let $date = $filter('date');

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			vm.transfer = {};
			vm.teams = [];
			TeamsFactory.getAll({page_size:2000}).then(response =>{
				vm.teams = response.data;
			});
			TransfersFactory.getAll({page_size:2000}).then(response =>{
				vm.gridOptions.data = response.data;
			});
		};

		vm.dateConfig = {startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown'};

		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'date',
					enableFiltering: false,
					name: $translate('DATE'),
					width: '120'
				}, {
					field: 'player.playerName',
					enableFiltering: true,
					name: $translate('PLAYER'),
				},  {
					field: 'oldTeam.teamName',
					enableFiltering: true,
					name: $translate('OLD_TEAM'),
				}, {
					field: 'newTeam.teamName',
					enableFiltering: true,
					name: $translate('NEW_TEAM'),
				},  {
					field: 'comments',
					enableFiltering: false,
					name: $translate('COMMENTS'),
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div ' +
					'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button class="btn btn-sm btn-warning" translate ' +
					'data-toggle="modal" ' +
					'data-target="#transferModal" ' +
					'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.MAKE_PLAYER_TRANSFER)" ' +
					'ng-click="grid.appScope.vm.openTransferModal(row.entity)">EDIT</button> ' +
					'</div>' +
					'</div>',
					width: '130',
				},
			],
		};

		vm.hasPermission = (permission) =>{
			return vm.rootScope.user.canDo(permission);
		};

		vm.openTransferModal = (transfer) =>{
			vm.transfer = {};
			angular.copy(transfer, vm.transfer);
		};

		vm.submit = () =>{
			vm.transfer.date = $date(vm.transfer.date, 'yyyy-MM-dd');
			TransfersFactory.update(vm.transfer.transfer_id, vm.transfer).then(response =>{
				ngDialog.open({template: 'successTemplate'});
				$state.reload();
			});
		}
	}
}

export default TransfersController;



// WEBPACK FOOTER //
// ./client/app/components/transfers/transfers.controller.js